import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import IndexNavbar from "../../components/Navbars/IndexNavbar";
import Footer from "../../components/Footers/IndexFooter";

const UserAgreementPage = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language.startsWith("en");

  const content = isEnglish
    ? {
        title: "User Agreement",
        intro:
          "This User Agreement establishes the rules for using the site’s calculators, services and other functionality provided for informational purposes.",
        sections: [
          {
            title: "1. General provisions",
            paragraphs: [
              "1.1. The User confirms that they have read and accepted this Agreement in full.",
              "1.2. The Site provides access to interactive calculators and tools intended for approximate, reference and informational use.",
            ],
          },
          {
            title: "2. Informational nature of results",
            paragraphs: [
              "2.1. All calculations, estimates, recommendations and other results generated by the Site’s calculators are for informational, reference and approximate use only.",
              "2.2. Calculation results are not an official expert opinion, medical, legal, technical, financial or other professional consultation.",
              "2.3. The Site does not guarantee that calculation results fully match real facts, conditions, circumstances or the actual state of an object, event or process.",
              "2.4. Any information obtained through the calculators may not account for all individual circumstances, assumptions, limitations and external factors relevant to a specific case.",
            ],
          },
          {
            title: "3. No warranty",
            paragraphs: [
              "3.1. The Site Operator does not guarantee the accuracy, completeness, timeliness, reliability, applicability and truthfulness of any information produced by the calculators.",
              "3.2. The Site Operator does not guarantee that calculator results correspond to the actual state of an object, phenomenon, process or circumstance.",
              "3.3. No calculations obtained through the Site may be treated as a final conclusion having legal force, expert value or binding effect.",
            ],
          },
          {
            title: "4. User responsibility",
            paragraphs: [
              "4.1. The User independently enters the data, checks its correctness and assesses the applicability of the calculation results to their specific situation.",
              "4.2. The User assumes all risks associated with using the calculator results, including making decisions on their basis.",
              "4.3. The User agrees not to use the website results as the sole basis for official actions, conclusions or medical, legal, technical or financial decisions.",
            ],
          },
          {
            title: "5. Limitation of liability",
            paragraphs: [
              "5.1. The Site Operator is not liable for direct, indirect, incidental, consequential, punitive or other losses arising from the use or inability to use the calculators and their results.",
              "5.2. The Site Operator is not liable for any consequences arising from misinterpretation of calculation results, incorrect data entry, algorithm limitations, or incomplete understanding of the informational nature of the data.",
              "5.3. To the maximum extent permitted by applicable law, this Agreement is applied as allowed by the legislation of the Russian Federation.",
            ],
          },
          {
            title: "6. Changes to functionality and conditions",
            paragraphs: [
              "6.1. The Site Operator may change the algorithms, methods, interface and functionality of the calculators, as well as amend this Agreement.",
              "6.2. Continued use of the Site after changes means acceptance of the updated terms.",
            ],
          },
          {
            title: "7. Final provisions",
            paragraphs: [
              "7.1. The User confirms that they understand and accept that all calculation results provided by the Site are informational in nature and may not reflect reality.",
              "7.2. The Site Operator is not responsible for results obtained through use of the calculators if they are used without proper independent verification and assessment.",
              "7.3. This Agreement is effective for all users of the Site and may be amended by the Operator without prior notice, unless such amendment conflicts with the law of the Russian Federation.",
            ],
          },
        ],
      }
    : {
        title: "Пользовательское соглашение",
        intro:
          "Настоящее Пользовательское соглашение устанавливает правила использования калькуляторов, сервисов и иных функциональных возможностей сайта, предоставляемых в информационных целях.",
        sections: [
          {
            title: "1. Общие положения",
            paragraphs: [
              "1.1. Пользователь подтверждает, что ознакомился с настоящим Соглашением и принимает его условия в полном объёме.",
              "1.2. Сайт предоставляет доступ к интерактивным калькуляторам и инструментам, предназначенным для ориентировочного, справочного и информационного использования.",
            ],
          },
          {
            title: "2. Информационный характер результатов",
            paragraphs: [
              "2.1. Все расчёты, оценки, рекомендации и прочие результаты, формируемые калькуляторами сайта, носят исключительно ориентировочный, информационный и справочный характер.",
              "2.2. Результаты расчётов не являются официальным экспертным заключением, медицинской, юридической, технической, финансовой или иной профессиональной консультацией.",
              "2.3. Сайт не гарантирует, что результаты расчётов полностью соответствуют реальным фактам, обстоятельствам, состоянию объекта, событию или процессу.",
              "2.4. Любая информация, полученная с помощью калькуляторов, может не учитывать все индивидуальные особенности, условия, ограничения, допущения и внешние факторы, присутствующие в конкретной ситуации.",
            ],
          },
          {
            title: "3. Отсутствие гарантии",
            paragraphs: [
              "3.1. Оператор сайта не гарантирует точность, полноту, актуальность, достоверность, применимость и соответствие действительности любой информации, рассчитанной или сформированной с помощью калькуляторов.",
              "3.2. Оператор сайта не предоставляет гарантий того, что результаты расчётов будут соответствовать реальному состоянию объекта, явления, процесса или обстоятельства.",
              "3.3. Никакие расчёты, полученные на сайте, не могут рассматриваться как окончательный вывод, имеющий юридическую силу, экспертную ценность или обязательный характер.",
            ],
          },
          {
            title: "4. Ответственность Пользователя",
            paragraphs: [
              "4.1. Пользователь самостоятельно вводит исходные данные, проверяет их корректность и оценивает применимость результатов расчётов к своей конкретной ситуации.",
              "4.2. Пользователь принимает на себя весь риск, связанный с использованием результатов работы калькуляторов, включая принятие решений на их основе.",
              "4.3. Пользователь обязуется не использовать результаты сайта как единственное основание для официальных действий, заключений, медицинских, юридических, технических или финансовых решений.",
            ],
          },
          {
            title: "5. Ограничение ответственности",
            paragraphs: [
              "5.1. Оператор сайта не несёт ответственности за прямые, косвенные, случайные, сопутствующие, штрафные или иные убытки, возникшие в связи с использованием калькуляторов, их результатов, а также в связи с невозможностью использования сайта или его отдельных функций.",
              "5.2. Оператор сайта не несёт ответственности за любые последствия, возникшие в результате неверной интерпретации результатов расчётов, ошибочного ввода данных, ограничений алгоритмов, а также неполного или некорректного понимания Пользователем характера представляемой информации.",
              "5.3. В случае, если законодательством Российской Федерации предусмотрены ограничения по освобождению от ответственности, данное Соглашение применяется в максимально допустимой степени.",
            ],
          },
          {
            title: "6. Изменение функционала и условий",
            paragraphs: [
              "6.1. Оператор сайта вправе изменять алгоритмы, методики, интерфейс и функционал калькуляторов, а также вносить изменения в настоящее Соглашение.",
              "6.2. Продолжение использования сайта после внесения изменений означает принятие Пользователем обновлённых условий.",
            ],
          },
          {
            title: "7. Заключительные положения",
            paragraphs: [
              "7.1. Пользователь подтверждает, что понимает и принимает, что все результаты расчётов, предоставляемые сайтом, имеют исключительно информационный характер и могут не отражать реальную действительность.",
              "7.2. Оператор сайта не несёт ответственности за результаты, полученные в ходе использования калькуляторов, если они использованы без должной самостоятельной проверки и оценки.",
              "7.3. Настоящее Соглашение действует в отношении всех пользователей сайта и может быть изменено оператором без предварительного уведомления, если такое изменение не противоречит законодательству Российской Федерации.",
            ],
          },
        ],
      };

  return (
    <>
      <IndexNavbar />
      <main className="section section-lg pt-7">
        <Container className="mt-5 mb-5">
          <Row className="justify-content-center">
            <Col lg="12">
              <Card className="shadow border-0">
                <CardBody className="p-5">
                  <h1 className="mb-4">{content.title}</h1>
                  <p>{content.intro}</p>

                  {content.sections.map((section) => {
                    console.log('[render debug] UserAgreement sections', { title: section.title, paragraphCount: section.paragraphs?.length });
                    return (
                      <React.Fragment key={String(section.title)}>
                        <h3 className="mt-4">{section.title}</h3>
                        {section.paragraphs.map((paragraph, index) => (
                          <p key={`${String(section.title)}-${index}`}>{paragraph}</p>
                        ))}
                      </React.Fragment>
                    );
                  })}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default UserAgreementPage;
